import _ from 'lodash';
import {InputTypeDoc} from 'module/CustomField/util/CFInputType';
import '../style/DeprecatedCFInputType.css'

interface DocDqEl {
	value: string
	label: string
}

const evoAppsDeprecatedCFInputTypeDoc: Record<string, Record<string, string>> = {
	0: {
		1: 'evoApps: ',
	},
	1: {
		0: '',
		1: 'Ziffernblock + P',
		2: 'Ziffernblock',
		3: 'Telefonziffernblock',
		4: 'Ziffernblock + :',
	},
	2: {
		0: '',
		1: 'Combobox mit Auswahl, Label',
		2: 'Combobox mit Label',
		3: 'Combobox mit Auswahl',
		4: 'nur Datenqellen-Validierung',
		B: 'Buttons statt Inputfeld/Combobox',
		X: 'dq konvertiert label zu value',
		L: 'nur label',
	},
	3: {
		0: '',
		1: 'mit Buffer',
	},
}
const MobileTimerDeprecatedCFInputTypeDoc = {
	'0010': 'Eingabe oder Auswahl',
	'0011': 'nur Auswahl',
	'0020': '(Eingabe oder Auswahl) oder Scan',
	'0021': 'nur Auswahl oder Scan (RFID oder Barcode)',
	'0030': '(Eingabe oder Auswahl) oder Scan (nur RFID)',
	'0031': 'nur Auswahl oder Scan (nur RFID)',
	'0040': '(Eingabe oder Auswahl) oder Scan (nur Barcode)',
	'0041': 'nur Auswahl oder Scan (nur Barcode)',
	'0050': 'Scan (RFID oder Barcode)',
	'0051': 'Scan (nur RFID)',
	'0052': 'Scan (nur Barcode)',
	'0060': 'CheckBox  (J/[N])',
	'0061': 'CheckBox  (J/[N])  -> bei J Bemerkung zwingend',
	'0062': 'CheckBox  (J/[N])  -> bei N Bemerkung zwingend',
	'0070': 'RadioButton (J/N) – nichts vorausgewählt',
	'0071': 'RadioButton (J/N) -> bei J Bemerkung zwingend',
	'0072': 'RadioButton (J/N) -> bei N Bemerkung zwingend',
	'0080': 'Unterschrift',
	'0090': 'Foto',
	'0100': 'Einlesen von QR-Codes mit Werten für mehrere Eingabefelder',
}

/* Backgrid cell doc generated with (only working in Backgrid apps i.e. maintenance.jsp):

(function(){
		const staticDescriptions = {
			StringCell: 'normales Feld, nullable, Backgrid Standard',
			IntegerCell: 'mit Trennpunkten',
		}

		function getDescriptionForCell(obj, cellName) {
			return staticDescriptions[cellName] || obj.prototype._sisCellDescription || '<span class="CFInputNoInfo">Keine Beschreibung verfügbar</span>';
		}

		function mapCellCb(obj, name) {
			//ignored
			if (!_.endsWith(name, 'Cell') ||
				_.includes(['Cell', 'HeaderCell'], name) ||
				obj && obj.prototype && obj.prototype._sisCellHide
			) return;
			return {
				value: name.substr(0, name.length - 4),
				label: "//deprecated [Maintenance-ALT] " + getDescriptionForCell(obj, name),
			};
		}

		return _.compact(
				_.map(window.sis.Backgrid, mapCellCb)
					.concat(
						_.map(window.sis.Backgrid.Extension, mapCellCb),
					)
			).filter(x=>!['Time', 'Date', 'DateTime', 'Datetime', 'MaintenanceMappingToMany','MaintenanceMappingToOne','Control', 'ControlHeader', 'HtmlHeader'].includes(x.value))
		})()

*/
const BackgridDeprecatedCFInputTypeDoc = [
	{
		"value": "String",
		"label": "//deprecated [Maintenance-ALT] normales Feld, nullable, Backgrid Standard",
	},
	{
		"value": "Uri",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Email",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Number",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Integer",
		"label": "//deprecated [Maintenance-ALT] mit Trennpunkten",
	},
	{
		"value": "Percent",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Boolean",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Select",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Moment",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Dq",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Id",
		"label": "//deprecated [Maintenance-ALT] Ohne Trennpunkt, wie Integer",
	},
	{
		"value": "JaNeinCheckbox",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Key",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "KBerschl",
		"label": "//deprecated [Maintenance-ALT] Verwendet als Datenquelle den KBERSCHL des aktuellen Benutzers.<br><small>Beim initialisieren werden die Kostenstellen einmal geladen. Danach können alle Kostenstellen am Client verwendet werden.</small>",
	},
	{
		"value": "CustomFieldAvailableInputTypes",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Verbose",
		"label": "//deprecated [Maintenance-ALT] Custom-Field Regeln deaktiviert! Formatiert die eingegebenen Werte nach der Eingabe so, dass unsichtbare Zeichen sichtbar sind.",
	},
	{
		"value": "Raw",
		"label": "//deprecated [Maintenance-ALT] Ohne Custom-Field Regeln! Zeigt 'null' Werte als null an.",
	},
	{
		"value": "SisDate",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "SisDuration",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "HexColor",
		"label": "//deprecated [Maintenance-ALT] Transformiert die Eingabe und färbt die Zelle nach der Eingabe.",
	},
	{
		"value": "SisTime",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "SisName",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "Evaluation",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "ApplicationScope",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "SisBoolean",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
	{
		"value": "AktivStatus",
		"label": "//deprecated [Maintenance-ALT] <span class=\"CFInputNoInfo\">Keine Beschreibung verfügbar</span>",
	},
]

function generateFromDeprecatedInput() {
	let result: DocDqEl[] = [];
	// MobileTimer
	result = result.concat(Object.entries(MobileTimerDeprecatedCFInputTypeDoc).map(
		([input, label]) => ({
			value: input,
			label: `[MobileTimer] ${label}`,
		}),
	));

	// evoApps
	let inputValues = [
		Object.keys(evoAppsDeprecatedCFInputTypeDoc[0]),
		Object.keys(evoAppsDeprecatedCFInputTypeDoc[1]),
		Object.keys(evoAppsDeprecatedCFInputTypeDoc[2]),
		Object.keys(evoAppsDeprecatedCFInputTypeDoc[3]),
	]
	inputValues[0].forEach((d0) =>
		inputValues[1].forEach((d1) =>
			inputValues[2].forEach((d2) =>
				inputValues[3].forEach((d3) => {
					result.push({
						value: [d0, d1, d2, d3].join(''),
						label: '//deprecated [Terminal-ALT] ' + [
							evoAppsDeprecatedCFInputTypeDoc[0][d0],
							evoAppsDeprecatedCFInputTypeDoc[1][d1],
							evoAppsDeprecatedCFInputTypeDoc[2][d2],
							evoAppsDeprecatedCFInputTypeDoc[3][d3],
						].join(', '),
					})
				}))));

	return result;
}

let dq: undefined | DocDqEl[];

export function getCustomFieldAvailableInputTypes() {
	if (!dq) {
		dq = [
			...BackgridDeprecatedCFInputTypeDoc,
			...generateFromDeprecatedInput(),
			...Object.entries(InputTypeDoc).map(([key, v]) => ({value: key, label: `[React] ${v}`}))
		]
		dq = dq.map(x => x.label.substring(0, 13) === '//deprecated ' ? {
			...x,
			label: `<span class="${
				!dq?.find(other =>
					// other, not deprecated input with same value available => do not mark red
					other.value === x.value && other.label.substring(0, 13) !== '//deprecated ',
				) ? 'deprecatedCFInput' : ''
			}">${x.label.substring(13)} // deprecated!</span>`,
		} : x)
		dq = _.sortBy(dq, "value")
	}
	return dq
}